import Request from '../request';

export interface ITargetSummaryProps {
    employeeId: string;
    month: string;
    date: string;
    targetAmount: number;
    targetType: 'omset' | 'profit' | string;
    achievedAmount: number;
    remainingAmount: number;
    percentage: number;
    isTargetMet: boolean;
    ordersCount: number;
    contract?: {
        id: string;
        startDate?: string;
        endDate?: string;
    };
}

const EmployeeTargetSummaryService = {
    get: async (employeeId: string, date?: string): Promise<ITargetSummaryProps> => {
        let url = `/api/employees/${employeeId}/target-summary`;
        if (date) {
            url += `?date=${encodeURIComponent(date)}`;
        }
        const response = await Request.get(url);
        return (response && response.percentage !== undefined) ? response : (response?.data || response);
    }
};

export default EmployeeTargetSummaryService;
